jQuery(document).ready(function($){

	$('#alert-bar .alert-close').click(function(){
		$('#alert-bar').hide();
		$('#wrapper-navbar').css("margin-top", "0");
	});

  if ( $(window).width() <= 768 ) {

  	//open menu on click, expand dropdown menu
  	$('#menuToggle').click(function(e){
			$('.navbar-wrapper').toggleClass('active');
			$('.dropdown-menu').addClass('show');
		});

  } else {

  	//open menu on hover for desktop
		$('#menuToggle, #navbarNavDropdown').hover(function(){
			$('.navbar-wrapper').addClass('active');
		}, function(){
			$('.navbar-wrapper').removeClass('active');
		});

		//add dropdown menu toggle functionality to down arrow
		$('.dropdown-toggle.nav-link').append('<a href="#" class="ms-3" data-toggle="dropdown" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa-solid fa-chevron-down"></i></a>');
  	
  	$('.dropdown-toggle.nav-link a').click(function(e){
  		$( this ).toggleClass('active');
  		$( this ).parent().siblings('.dropdown-menu').toggleClass('show');
  	})
  }

	//when scrolled past hero add color to nav
  window.addEventListener("scroll", function() {
	  var heroBlock = $(".hero");
	  var headerBlock = $("header");

	  if ( window.scrollY > ( heroBlock.height() || headerBlock.height() ) ) {
      $('.navbar-wrapper').addClass('scroll');
	  } else {
	  	$('.navbar-wrapper').removeClass('scroll');
	  }
	});

  //search icon open input on click
	$('#searchToggle').on('click', function(e){
		e.preventDefault();
		$('.navbar-wrapper').toggleClass('search-active');
		$('.search-input').focus();
		return false;
	});

	//change facets sort dropdown to radio buttons
  var sortfacet = 'arrange_by';

  $(document).on('click', '.sort-radio', function() {
    var val = $(this).attr('data-value');
    FWP.facets[sortfacet] = [val];
    FWP.toggleOverlay('on');
    FWP.fetchData();
    FWP.setHash();
  });

  //when facet is clicked, scroll to top of page
  $(document).on('facetwp-refresh', function() {
    if (FWP.soft_refresh == true) {
      FWP.enable_scroll = true;
    } else {
      FWP.enable_scroll = false;
    }
  });

  $(document).on('facetwp-loaded', function() {
    if ('undefined' !== typeof FWP.facets[sortfacet]) {
      $('.sort-radio').filter('[data-value="' + FWP.facets[sortfacet] + '"]').addClass("checked");
    }

    if (FWP.enable_scroll == true) {
      $('html, body').animate({
        scrollTop: 0 // Scroll to the top of the page
      }, 500);
    }
  });
	$(".translate-button").click(function(){
	  $(".translate-button").toggleClass("active");
//		alert("button clicked");
	});
});

document.addEventListener("DOMContentLoaded", function(event) {

  window.addEventListener("load", function(e) {
    
    gsap.registerPlugin(ScrollTrigger);

    let fade = [
    	'.acf-innerblocks-container h2',
    	'.button.custom-button',
    	'.carousel .content-wrapper .content-row-text',
    	'.carousel.image-right-side .carousel-inner',
    	'.content-row-text',
    	'.hero-caption h1',
    	'.hero-caption p.hero-subheader',
    	'.hero-caption a.hero-button',
    	'.hero-caption .page-title',
    	'.testimonial-block .testimonial-slide-buttons',
    	'.testimonial-block .testimonial-right',
    	'.toggle-content-box'
    ];

    fade.forEach((text, i) => {
    	gsap.to(text, {
    		stagger: 0.5,
				opacity: 1,
				y: 0,
				ease: "back.out(1.7)",
				scrollTrigger: {
					trigger: text
				}
			});
    });

		let footerQueryFades = gsap.utils.toArray(".fade-in");
		footerQueryFades.push(
			'.post-query-block .post-box',
			'.content-slider-box',
			'.block-content-overlay'
		);

		footerQueryFades.forEach((fade, i) => {
		  gsap.to(fade, {
		    duration: 1,
			  stagger: 0.5,
			  opacity: 1,
			  y: 0,
		    scrollTrigger: {
		      trigger: fade
		    }
		  })
		});

		var countTimeline = gsap.timeline({
			scrollTrigger: {
				trigger: document.querySelectorAll('.counter'),
				start: 'top bottom',
				once: true
			},
		});

		gsap.utils.toArray('[data-counter]').forEach(function(el){
			var target = { val: 1 };
			countTimeline.to(target, {
				val: el.getAttribute('data-counter'),
				duration: el.getAttribute('data-speed'),
				onUpdate: function(){
					el.innerText = target.val.toFixed(0);
				}
			}, "+=-10")
		})

  }, false);
 
});